// App-level identity (distinct from the center identity configured via /parametres)
// The center identity (name, logo, subtitle, primary_color) comes from SettingsContext.
// The app identity is fixed and displayed discreetly as a "Propulsé par ..." badge.

export const APP_NAME = "Dervan";
export const APP_TAGLINE = "Le cœur numérique de vos projets solidaires";
export const APP_TAGLINE_SECONDARY = "Cultiver l'impact. Relier les acteurs.";
export const APP_LOGO_URL = "/images/dervan-icon.png";           // square icon for nav/badges (tree only, transparent)
export const APP_LOGO_WIDE_URL = "/images/dervan-logo-800.png";  // wide "tree + DERVAN wordmark + tagline" version

// Brand palette (v2 - août 2026)
export const BRAND_COLORS = {
  navy: "#0A2D4D",       // confiance / numérique (primary)
  turquoise: "#00A8B5",  // connexion / circulation
  green: "#53C268",      // impact / développement
  lime: "#A8D600",       // énergie / innovation
  orange: "#FF9F1C",     // humain / action
};

// Default center logo fallback when none has been uploaded in admin settings.
// The uploaded image (CSCS-MJC Rives de Charente) is served from /public.
export const DEFAULT_CENTER_LOGO = "/centre-logo/centre-logo.jpg";
export const DEFAULT_CENTER_NAME = "CSCS-MJC Rives de Charente";
